import React, { useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { Button, Col, Row } from 'react-bootstrap';
import Table from '@awp/components/table';
import { toast } from 'react-toastify';

import { FORM_MODE } from '@awp/constants';
import * as PresetSlice from '@stores/graphPresetSlice';
import { PresetTableColumns } from './PresetTableColumns';
import * as PresetHelper from './Helpers/PresetHelper';
import AwpMessageModal from '@components/Common/AwpMessageModal';
import GraphPresetService from '@graphs/Presets/GraphPresetService';

const GraphPresetTable = ({ ...props }) => {
  const { mode } = props;
  const dispatch = useDispatch();

  const fullData = useSelector((state) => PresetSlice.selectAllGraphPresets(state));
  const [errors, setErrors] = useState(null);
  const [showDeleteModal, setShowDeleteModal] = useState(false);
  const [actionId, setActionId] = useState(null);

  const { canManagePrivate, canManagePublic } = PresetHelper.getManagePermissions(props.currentUser);

  const crudService = new GraphPresetService(mode);

  return (
    <>
      <div className="d-flex">{crudService.crud.getHeader()}</div>
      <Table
        id="preset_table"
        columns={PresetTableColumns({
          breakpoints: props.breakpoints,
          setMode: props.setMode,
          setPresetId: props.setPresetId,
          dispatch: dispatch,
          setShowDeleteModal: setShowDeleteModal,
          setActionId: setActionId,
          currentUser: props.currentUser,
        })}
        data={fullData}
        fetchData={() => {}}
        loading={props.loading}
        search={[]}
        filters={[]}
        dataTriggers={[]}
        defaultSortBy="AppLastUpdateTimestamp"
        index={props.index}
        setIndex={props.setIndex}
        sort={props.sort}
        setSort={props.setSort}
        defaultPageSize={props.defaultPageSize}
        setDefaultPageSize={props.setDefaultPageSize}
      />
      {canManagePrivate || canManagePublic ? (
        <div className="my-3">
          <Row>
            <Col sm={3} md={4}>
              <Button
                className="mr-2 my-3"
                variant="primary"
                onClick={() => {
                  dispatch(PresetSlice.createPreset({ userSID: props.currentUser.SecurityIdentifierId }));
                  props.setPresetId(-1);
                  props.setMode(FORM_MODE.CREATE);
                }}
                disabled={props.loading}
              >
                Create Preset
              </Button>
            </Col>
          </Row>
        </div>
      ) : null}
      <AwpMessageModal
        showModal={showDeleteModal}
        setShowModal={setShowDeleteModal}
        actionId={actionId}
        primaryClick={async (presetId) => {
          const success = false;

          try {
            const result = await PresetHelper.deletePreset(presetId, dispatch);
            if (result) {
              toast.success('Preset was deleted successfully.');
            } else {
              toast.error('Delete failed.', { autoClose: 5000 });
            }
          } catch (error) {
            // Handle the error if necessary
            toast.error('Delete failed.', { autoClose: 5000 });
            console.error('An error occurred deleting the Preset:', error);
          }
        }}
        buttonType={0}
        title={'Confirm Delete'}
        body={'Are you sure you want to delete?'}
      />
    </>
  );
};

export default GraphPresetTable;
